import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-tabla-documentos',
  templateUrl: './tabla-documentos.component.html',
  styleUrls: ['./tabla-documentos.component.scss']
})
export class TablaDocumentosComponent implements OnInit {
  @Input() titulo: string = '';
  @Input() verDocumentos: boolean =  false;
  @Input() disabledActions: boolean = false;
  @Input() flagBotonDocs: boolean = false;
  @Input() dataSource: any [] = [];
  @Input() maxSize: number = 1200;
  @Input() limitFilePDF: string = '';
  @Input() limitFileJPG: string = '';
  @Input() filesAccept: string = 'application/pdf,image/jpeg';

  @Output() verEvent = new EventEmitter ();
  @Output() adjuntarEvent = new EventEmitter ();
  @Output() eliminarEvent = new EventEmitter ();

  allColumns: any [] = ['item', 'tipo_documento', 'documento_adjunto', 'adjuntar', 'eliminar', 'ver'];
  constructor(private toastr: ToastrService) {

  }

  ngOnInit() {

  }

  toggleDocumentos() {
    this.verDocumentos = !this.verDocumentos;
  }

  ver(event: any) {
    this.verEvent.emit(event);
  }

  adjuntar(item: any, event: any) {
    if (event.target.files.length > 0) {
      if (this.validarFilesAccept (event.target.files [0])) {
        this.adjuntarEvent.emit({item: item, file: event.target.files [0]});
        event.target.value = null;
      } else {
        this.toastr.warning("Archivo adjunto inválido, solo se permite archivos PDF e imágenes JPG", "Atención");
      }
    }
  }

  validarFilesAccept (file: any) {
    return this.filesAccept.split (',').indexOf (file.type) > -1;
  }

  eliminar(event: any) {
    this.eliminarEvent.emit(event);
  }
}
